import { IArticle } from "../../../models/article.ts";
import { zendeskHttpRequest } from "../zendeskHttpRequest.ts";

export const updateArticle = async (
  token: string,
  brandUrl: string,
  article: IArticle,
) => {
  try {
    await zendeskHttpRequest(
      `help_center/articles/${article.id}/translations/${article.locale}`,
      token,
      "PUT",
      brandUrl,
      JSON.stringify({
        translation: {
          title: article.title,
          body: article.body,
          draft: article.draft,
        },
      }),
    );
  } catch (error) {
    throw "記事更新エラー(translations):" + error;
  }
  try {
    const data = await zendeskHttpRequest<{ article: IArticle }>(
      `help_center/articles/${article.id}`,
      token,
      "PUT",
      brandUrl,
      JSON.stringify({
        article: article,
        notify_subscribers: false,
      }),
    );
    return data.article;
  } catch (error) {
    throw "記事更新エラー(articles):" + error;
  }
};
